// Intake option sets from the design prototype. Priorities map onto the
// users.interests profile field; party maps onto politicalAffiliation.
export const PRIORITY_CHOICES = [
  'Education',
  'Environment',
  'Climate',
  'Housing',
  'Healthcare',
  'Public Safety',
  'Voting Rights',
  'Taxes',
  'Immigration',
  'Small Business',
  'Reproductive Rights',
  'Gun Laws',
  // Added 2026-08-14 (Angie): the subject audit showed these high-volume
  // CGA subjects had no citizen topic — Transportation & Motor Vehicles (87
  // bills), Children & Domestic Matters (57), Military & Veterans (27).
  'Transportation',
  'Children & Families',
  'Military & Veterans',
  // Added 2026-08-14 (Angie): affordability is a cross-cutting lens, not a
  // CGA subject — it matches on bill titles (see topicSubjects ORPHAN note).
  'Affordability',
];

export interface PartyChoice {
  id: string;
  label: string;
  color: string;
}

export const PARTY_CHOICES: PartyChoice[] = [
  { id: 'democrat', label: 'Democratic', color: '#3B6BD9' },
  { id: 'republican', label: 'Republican', color: '#D33C3C' },
  { id: 'unaffiliated', label: 'Unaffiliated', color: '#6B7280' },
  { id: 'independent', label: 'Independent', color: '#1F9A55' },
  { id: 'green', label: 'Green', color: '#3F7C44' },
  { id: 'libertarian', label: 'Libertarian', color: '#C9742B' },
];
